<div class="frequent-stops-graph">
  <div class="frequent-stops-graph__header">
    <h4 class="frequent-stops-graph__title">{{ 'driverDashboard.graphs.frequentStops' | transloco }}</h4>
    <app-date-filter
      [filter]="dateFilter"
      [isButtonIntervalSelector]="false"
      [datePickerPlacement]="'top'"
      (filterChanged)="onDateFilterChange($event)">
    </app-date-filter>
  </div>

  <div class="frequent-stops-graph__body">
    @if (isLoading) {
      <div class="frequent-stops-graph__spinner spinner-border"></div>
    } @else if (hasError) {
      <app-graph-error-state></app-graph-error-state>
    } @else if (!hasData) {
      <div class="frequent-stops-graph__no-data">
        <app-empty-state></app-empty-state>
      </div>
    } @else {
      @defer (on timer(100ms)) {
        <div class="frequent-stops-graph__content">
          <div class="frequent-stops-graph__chart">
            <app-donut-chart
              [data]="chartData"
              [innerRadiusRatio]="0.6"
              [width]="140"
              [height]="140"
              [showPercentageOnHover]="true"
              (segmentHover)="onSegmentHover($event)">
            </app-donut-chart>
          </div>

          <div class="frequent-stops-graph__legend">
            @for (item of legendItems; track item.label) {
              <div class="legend-item" [class.highlighted]="hoveredSegmentName === item.label">
                <div class="legend-header">
                  <div class="legend-indicator" [style.background-color]="item.color"></div>
                  <span class="legend-label" [title]="item.label">{{ item.label }}</span>
                </div>
                <span class="legend-value">{{ item.value }}</span>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>